import { APIResponse, APIResponseDtoImpl } from '../../apiresponse';

export interface SetStatusToneResponse extends APIResponse
{
    // getGetTonePriceDto(): GetTonePriceDto;
}

export class SetStatusToneResponseDtoImpl extends APIResponseDtoImpl implements SetStatusToneResponse
{
    /* private getTonePriceRespnseDto : GetTonePriceDto;

    getGetTonePriceDto(): GetTonePriceDto
    {
        return this.getTonePriceRespnseDto;
    }
    setTonePriceDto(getTonePriceRespnseDto: GetTonePriceDto)
    {
        this.getTonePriceRespnseDto = getTonePriceRespnseDto;
    } */
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/statustune/setstatustune/setstatustonepriceresponse.tsx